import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';

import { a } from './_csAbt';
import * as gs from './_csGbl';
import * as ls from './_csLcl';
import { useLdrz } from './_csLdr';
import { useMsgz } from './_csMdlMsg';

import * as BoxC from './_ccbBoxC';
import * as BtnC from './_cccBtnC';
import * as IptC from './_ccbIptC';
import * as LblC from './_cccLblC';

/*
let $id = '';
let $pwd = '';
*/

export const N = React.memo((pz: { // send code
  cz: {
    idz: {
      id: ht.s,
      pwd: ht.s,
    },
    ccd?: ht.s,
    grtCfmz?: () => ht.dz,
    bfrCfm?: () => ht.b,
    atrCfm: (_10rz: ht.dz) => void,
    bHideId: ht.b,
    id?: ht.s,
    _10rs?: ht.ls,
//    onChg: (_dz: ht.dz) => void,
  }
}) => {

  const _gUserz = gs.useUserz();
  const _sMsgz = useMsgz();
  const _sLdrz = useLdrz();

  const _udtThis = ls.udtThis();

/*
  React.useEffect(() => {
    if (pz.cz.id) {
      $id = pz.cz.id;
    }
  }, [
    pz.cz.id
  ])
*/

  const _lgn = async () => {
    let _b1 = true;
    if (pz.cz.bfrCfm) _b1 = await pz.cz.bfrCfm();
    if (!_b1) return;
    _sLdrz.show();
    const _b2 = await hf.ectSrlAsync([
      async () => {
        let _b = true;
        if (
          pz.cz.bHideId != true && 
//          !hf.f($id)
          !hf.f(pz.cz.idz.id)
        ) _b = false;
        if (!_b) {
          _sMsgz.show({
            textCz: {
              textz: {
                pfx: `ログインIDを入力してください`
              }
            }
          })
        }
        return _b;
      },
      async () => {
        let _b = true;
        if (
//          !hf.f($pwd)
          !hf.f(pz.cz.idz.pwd)
        ) _b = false;
        if (!_b) {
          _sMsgz.show({
            textCz: {
              textz: {
                pfx: `パスワードを入力してください`
              }
            }
          })
        }
        return _b;
      },
    ])
    if (!_b2) {
      _sLdrz.hide();
      return;
    }
    else {
      const _dz = await f.cfmIdAsync({
        dmn: _gUserz.crt._dmn,
/*
        id: $id,
        pwd: $pwd,
*/
        id: pz.cz.idz.id,
        pwd: pz.cz.idz.pwd,
        ... pz.cz.grtCfmz ? pz.cz.grtCfmz() : undefined,
      });
      //hf.l(`LgnId 43: ${hf.s(_dz)}`);
      if (_dz.err) {
        _sMsgz.show({
          textCz: {
            textz: {
              pfx: '認証に失敗しました',
            }
          }
        })
        _sLdrz.hide();
      }
      else {
        await _gUserz.saveAsync({
          _10rz: _dz._10rz,
        });
        _sLdrz.hide();
//        $id = ''; $pwd = ''; // logout 時の初期化を考慮
        hf.udtDz(pz.cz.idz, {
          id: '',
          pwd: '',
        }); // logout 時の初期化を考慮
        pz.cz.atrCfm(_dz._10rz);
      }
    }
  }

  return (
    cr.c(BoxC.N, {
      key: `LgnID.N`,
      boxStlz: a('dw/f'),
      oClds: [

        pz.cz.bHideId != true ?
        cr.c(LblC.N, {
          key: -10,
          abtType: 'vclStfz',
          boxStlz: a('mb/1'),
          lblCz: {
            textz: {
              pfx: 'ログインID',
              stlz: a(`tc/${pz.cz.ccd ?? 'lt9'}`),
            },
          },
          cttCz: {
            oClds: [
              pz.cz._10rs ?
              cr.c(IptC.S, {
                key: -10,
                cz: {
                  bEdit: true,
                  iptType: 'pcr',
                  ls: pz.cz._10rs,
//                  vle: $id,
                  onChg: (_dz: ht.dz) => {
/*
                    $id = _dz._10ra2100s;
                    $pwd = '';
*/
                    hf.udtDz(pz.cz.idz, {
                      id: _dz._10ra2100s,
                      pwd: '',
                    });
//                    if (pz.cz.onChg) pz.cz.onChg({ id: $id });
                    _udtThis();
                  }
                }
              })
              :
              cr.c(IptC.S, {
                key: -10,
                cz: {
                  bEdit: true,
                  bDrt: true,
                  iptType: 'text',
//                  vle: $id,
                  vle: pz.cz.idz.id,
                  onChg: (_s: ht.s) => {
//                    $id = _s;
                    hf.udtDz(pz.cz.idz, {
                      id: _s,
                    });
//                    if (pz.cz.onChg) pz.cz.onChg({ id: $id });
                  }
                }
              })
            ],
          }
        })
        : null,

        cr.c(LblC.N, {
          key: -20,
          abtType: 'vclStfz',
          boxStlz: a('mb/3'),
          lblCz: {
            textz: {
              pfx: 'パスワード',
              stlz: a(`tc/${pz.cz.ccd ?? 'lt9'}`),
            },
          },
          cttCz: {
            oClds: [
              cr.c(IptC.S, {
                key: -10,
                cz: {
                  bEdit: true,
                  bDrt: true,
                  bScr: true,
                  iptType: 'text',
//                  vle: $pwd,
                  vle: pz.cz.idz.pwd,
                  onChg: (_s: ht.s) => {
//                    $pwd = _s;
                    hf.udtDz(pz.cz.idz, {
                      pwd: _s,
                    });
                  }
                }
              })
            ],
          }
        }),

        cr.c(BtnC.N, {
          key: -30,
          abtType: 'nextCmnz',
          boxStlz: a(`sc/${pz.cz.ccd ?? 'lt9'}`),
          lblCz: {
            textz: {
              pfx: 'ログイン',
            }
          },
          pslPtyz: {
            onPress: _lgn,
          }
        }),

      ]
    })
  );
});
